import CrimsonArcLogoMark from './CrimsonArcLogoMark';

export default function Footer() {
  return (
    <footer className="ca-footer" data-analytics-section="footer">
      <div className="ca-container ca-footer__inner">
        <div className="ca-footer__brand">
          <span className="ca-logo ca-logo--footer">
            <span className="ca-logo__mark" aria-hidden>
              <CrimsonArcLogoMark />
            </span>
            <span className="ca-logo__text">CrimsonArc Technologies</span>
          </span>
          <p className="ca-footer__tagline">Technology that bridges vision and reality.</p>
          <p className="ca-footer__domain">
            <a href="https://crimsonarctechnologies.online/">crimsonarctechnologies.online</a>
          </p>
        </div>
        <nav className="ca-footer__nav" aria-label="Footer">
          <a href="#services">Services</a>
          <a href="#reach">Run anywhere</a>
          <a href="#verticals">Business &amp; civic</a>
          <a href="#philosophy">Philosophy</a>
          <a href="#contact">Contact</a>
        </nav>
        <p className="ca-footer__legal">© {new Date().getFullYear()} CrimsonArc Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
}
